import { TextField, styled } from "@mui/material";

export const FilterTextField = styled(TextField)`
  background-color: ${(props) => props.theme.palette.common.white};
  border-radius: ${(props) => props.theme.spacing(0.5)};
`;
